import _ from 'lodash'
import DatasetTreeItemSelector from 'scoreboard/datasets/records/dataset-tree-item-selector'

/**
 * 2nd step for rollup filters that use the "is" operator, which allows selection
 * of a single rollup tree item.
 */
const DatasetsRollupIsFilterStep2 = DatasetTreeItemSelector.extend({
	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.filter the filter that should be updated. The
	 * object will be mutated
	 *
	 * @param {Dataset} options.model the Dataset model for the filter
	 *
	 * @param {FilterWizard} options.wizard
	 */
	initialize: function (options = {}) {
		let filter = options.filter
		let field = options.model.getUnderlyingField(filter.fieldId)

		let tweakedOptions = _.extend({
			treeId: field.treeId,
			selectedId: _.keys(filter.rollupIsAnyFilters)[0],
			showKeys: field.showKeys,
			showClearButton: true
		}, options)

		DatasetTreeItemSelector.prototype.initialize.call(this, tweakedOptions)
	},

	render: function () {
		DatasetTreeItemSelector.prototype.render.apply(this, arguments)

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
	},

	saveState: function() {
		let selected = this.gardener.tree.selected()
		let trees = {}

		if (selected) {
			trees[selected.id] = 'item-rollups-and-descendants'
		}

		this.options.filter.rollupIsAnyFilters = trees
	},

	submit: function() {
		this.saveState()
		// important: this needs to go before calling superclass so that
		// the fact that the filter is valid is recorded properly
		this.options.filter.valid = true

		let selected = this.gardener.tree.selected()
		let treeItems = selected ? [ selected ] : []

		this.options.wizard.finish({ treeItems })
		this.trigger('done')
	}
})

export default DatasetsRollupIsFilterStep2

DatasetsRollupIsFilterStep2.__filename__ = 'datasets/filters/datasets-rollup-is-filter-step2.js'
